<template>
  <div
    v-if="visible"
    class="progress_bar"></div>
</template>

<script>

export default {
  name: 'Spinner',
  props: {
    visible: Boolean
  }
}
</script>

<style>

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes running-progress {
  0% {
    margin-left: 0px;
    margin-right: 100%;
  }
  50% {
    margin-left: 25%;
    margin-right: 0%;
  }
  100% {
    margin-left: 100%;
    margin-right: 0;
  }
}

.progress_bar, .progress_bar:before {
  height: 3px;
  width: 100%;
  margin: 0;
}
.progress_bar {
  position: fixed;
  top: 0;
  left: 0;

  background-color: #EEEEEE;
  display: flex;
  animation: fadeIn 2s ease;
}
.progress_bar:before {
  background-color: #757575;
  content: '';
  animation: running-progress 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
</style>
